module.exports = __webpack_public_path__ + "static/media/personalicon.158f8692.svg";